import React, { useCallback } from 'react';

import { useStepHook } from '../logic/useStepHook';
import { StepView } from './StepView';
import { WizardFlowActionType } from '../logic/WizardContext';
import { ReactComponent as Last4SSN } from '../../../assets/svg/last-four-ssn.svg';

interface SSNStepProps {
  nationalIdDescription?: string;
}
export const SSNStep = ({ nationalIdDescription }: SSNStepProps) => {
  const { dispatch, t } = useStepHook();

  const handleFulfillSSN = useCallback(
    (ssn: string) => {
      dispatch({ type: WizardFlowActionType.SET_DATA, payload: { lastFourSSN: ssn } });
      dispatch({ type: WizardFlowActionType.NEXT_STEP });
    },
    [dispatch],
  );

  const title = (
    <>
      {t(`CHANGE_PHONE.${!nationalIdDescription ? 'SSN' : 'NATIONAL_IDENTIFIER'}.TITLE`)}
      {nationalIdDescription && <div>{nationalIdDescription}</div>}
    </>
  );
  return (
    <StepView
      headLineSmallText={t('CHANGE_PHONE.SSN.SUB_HEADER')}
      buttonTitle={t('CHANGE_PHONE.BUTTON_TITLE')}
      handleClick={handleFulfillSSN}
      numOfDigits={4}
      svg={!nationalIdDescription ? Last4SSN : undefined}
    >
      {title}
    </StepView>
  );
};
